var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_236_3113",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H24V24H0V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_236_3113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9264 21.4268H22.2423C22.9542 21.4268 23.5312 20.8497 23.5312 20.1378V8.94854H0.46875V20.1378C0.46875 20.8497 1.04583 21.4268 1.75772 21.4268H9.80287",
    stroke: "#696EEB",
    strokeWidth: 0.856964,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2425 2.57373H1.75796C1.04607 2.57373 0.468994 3.15081 0.468994 3.8627V8.94873H23.5315V3.8627C23.5315 3.15081 22.9544 2.57373 22.2425 2.57373Z",
    stroke: "#696EEB",
    strokeWidth: 0.856964,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93534 18.7964H3.70509C3.32404 18.7964 3.01514 18.4875 3.01514 18.1064V12.2103C3.01514 11.8292 3.32404 11.5203 3.70509 11.5203H9.93534C10.3164 11.5203 10.6253 11.8292 10.6253 12.2103V18.1064C10.6253 18.4875 10.3164 18.7964 9.93534 18.7964Z",
    stroke: "#696EEB",
    strokeWidth: 0.856964,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82016 15.6172C5.88421 15.6172 5.12549 14.8585 5.12549 13.9225V13.215C5.12549 12.279 5.88421 11.5203 6.82016 11.5203C7.75611 11.5203 8.51483 12.279 8.51483 13.215V13.9225C8.51483 14.8585 7.75611 15.6172 6.82016 15.6172Z",
    stroke: "#696EEB",
    strokeWidth: 0.856964,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4751 18.5362C10.349 18.6947 10.1539 18.7964 9.93567 18.7964H3.70532C3.48703 18.7964 3.29245 18.6951 3.16626 18.5366L3.22185 18.2005C3.33018 17.544 3.78417 16.9971 4.4091 16.7693L5.45563 16.3879C5.64904 16.3178 5.78723 16.146 5.81418 15.9418L5.89387 15.3418C6.15984 15.516 6.47854 15.6173 6.82049 15.6173C7.16245 15.6173 7.4811 15.516 7.74754 15.3413L7.82718 15.9418C7.85418 16.146 7.99195 16.3178 8.18493 16.3879L9.23226 16.7693C9.8572 16.9971 10.3112 17.544 10.4195 18.2005L10.4751 18.5362Z",
    stroke: "#696EEB",
    strokeWidth: 0.856964,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8529 11.5205H13.1189",
    stroke: "#696EEB",
    strokeWidth: 0.856964,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5471 14.0312H20.853",
    stroke: "#696EEB",
    strokeWidth: 0.856964,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1189 14.0312H14.4997",
    stroke: "#696EEB",
    strokeWidth: 0.856964,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0684 18.7964H20.853",
    stroke: "#696EEB",
    strokeWidth: 0.856964,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4736 7.229L16.5477 4.40886C16.5697 4.35524 16.6456 4.35514 16.6677 4.40877L17.732 7.229",
    stroke: "#696EEB",
    strokeWidth: 0.856964,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8088 6.52637H17.4026",
    stroke: "#696EEB",
    strokeWidth: 0.856964,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1509 4.3686V7.229",
    stroke: "#696EEB",
    strokeWidth: 0.856964,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8509 4.6626C13.8509 4.6626 13.3376 4.23116 12.7323 4.4135C12.1765 4.58089 12.0988 5.22172 12.5009 5.48389C12.5009 5.48389 12.8955 5.65986 13.333 5.8213C14.3865 6.20985 13.9327 7.229 13.0846 7.229C12.66 7.229 12.3036 7.043 12.0879 6.80497",
    stroke: "#696EEB",
    strokeWidth: 0.856964,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26807 4.36859L7.24607 7.18606C7.26655 7.24372 7.3483 7.2432 7.36799 7.18522L8.30197 4.37384",
    stroke: "#696EEB",
    strokeWidth: 0.856964,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.87d3c87537166fa5336a807897ab1c1f.svg";
export { ForwardRef as ReactComponent };